import React, { useEffect } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { Close, SaveChanges } from '../../../Constant';


const CommonModal = ({ isOpen, toggler, size, title, onSave, children, bodyClass, formdata }) => {
  useEffect(() => {
      if (isOpen) {
          Object.keys(formdata).forEach(key => {
              const element = document.getElementById(key);
              if (element) {
                  element.value = formdata[key];
              }
          });
      }
  }, [isOpen, formdata]);

  const handleSubmit = () => {
      const formData = {};
      const fieldIds = Object.keys(formdata);

      fieldIds.forEach(id => {
          const element = document.getElementById(id);
          if (element) {
              formData[id] = element.value;
          }
      });

      onSave(formData);
      toggler();
  };

  return (
      <Modal isOpen={isOpen} toggle={toggler} size={size} centered>
          <ModalHeader toggle={toggler}>{title}</ModalHeader>
          <ModalBody className={bodyClass}>{children}</ModalBody>
          <ModalFooter>
              <Btn attrBtn={{ color: 'secondary', onClick: toggler }}>{Close}</Btn>
              <Btn attrBtn={{ color: 'primary', onClick: handleSubmit }}>{SaveChanges}</Btn>
          </ModalFooter>
      </Modal>
  );
};

export default CommonModal;
